// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

/**
 * Componente que renderiza un ícono con el funcionamiento de un botón.
 * @class
 * @example
 * <IconButton icon={IconOpen} />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {JSX.Element} props.icono - Icono a mostrar en el botón.
 * @param {string} props.color - Color del botón.
 * @param {boolean} props.disabled - Valor que indica si el ícono está desactivado.
 * @param {boolean} props.hover - Valor que indica si el ícono tiene animación al hacer hover.
 */
const IconButton = styled(({ icon: Icon, ...props }) => <Icon {...props} />)`
  color: ${({ color }) =>
    color === 'primary'
      ? colors.primary
      : color === 'secondary'
      ? colors.secondary
      : color === 'tertiary'
      ? colors.tertiary
      : color === 'dark'
      ? colors.text
      : color};
  cursor: pointer;
  margin: 0 0.25rem;
  transition: transform 0.15s, color 0.15s, filter 0.15s;
  user-select: none;

  ${(props) =>
    !props.disabled &&
    props.hover &&
    `
    &:hover {
      cursor: pointer;
      filter: brightness(0.75);
    }`}

  &:active {
    transform: scale(0.9);
  }

  ${({ disabled }) =>
    disabled &&
    `
  transform: scale(1);
  filter: brightness(1);
  filter: opacity(0.75);
  `}
`
export default IconButton
